import { render, staticRenderFns } from "./configure-new-form.vue?vue&type=template&id=7d034839&scoped=true&"
import script from "./configure-new-form.vue?vue&type=script&lang=js&"
export * from "./configure-new-form.vue?vue&type=script&lang=js&"
import style0 from "./configure-new-form.vue?vue&type=style&index=0&id=7d034839&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d034839",
  null
  
)

component.options.__file = "configure-new-form.vue"
export default component.exports